import classNames from "classnames";

import {AlertBodyProps} from "@/components/alert/subComponents/AlertBody/AlertBody.types.ts";

import styles from "./AlertBody.module.scss";

const AlertBody = ({children, className}: AlertBodyProps) => {
  return <div className={classNames(styles.body, className)}>{children}</div>;
};

AlertBody.displayName = "AlertBody";

export {AlertBody};
